<template>
	<div class="width-100 height-100 flex-centerize">
		<div class="slack-preview-container width-100 display-flex flex-column">
			<div class="display-flex flex-row">
				<img width="26" class="mr-5" v-if="icon" :src="icon" />
				<SIcon class="mr-5" name="logo-no-text" width="26" height="40" v-else />
				<div class="ply-name mr-2">Ply</div>
				<div class="app-indication flex-centerize">APP</div>
			</div>
			<div class="display-flex flex-row width-100 height-100 slack-content-container px-3">
				<div class="display-flex flex-column width-100 height-100 pr-7 flex-justify-space-between">
					<div>
						<div class="slack-text">{{ title }}</div>
						<div class="slack-description-text mt-3">
							<span class="additional-info">{{ additionalInfo }}</span>
						</div>
					</div>
					<div class="display-flex flex-row flex-align-center mt-6">
						<!-- <AnemicButton tile class="archive-button mr-4">Archive</AnemicButton> -->
						<AnemicButton tile class="take-action-button">{{ takeActionTitle }}</AnemicButton>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SlackNotificationTab',
	props: {
		title: { type: String },
		additionalInfo: { type: String },
		takeActionTitle: { type: String },
		icon: { type: String },
	},
	components: {},
	computed: {},
	methods: {},
	created() {},
	mounted() {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.slack-preview-container {
	min-height: 210px;
	border-radius: 5px;
	background: var(--white);
	font-family: Lato !important;
	padding: 28px 12px 24px 12px;
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);
}
.slack-text {
	font-size: 15px;
	color: #2c2b2c;
	letter-spacing: 0px;
}
.slack-description-text {
	font-size: 12px;
	color: #b8b8b8;
	letter-spacing: 0px;
}
.ply-name {
	font-size: 18px;
	color: #1d1c1d;
	font-weight: bold;
	letter-spacing: 0px;
}
.app-indication {
	width: 24px;
	height: 14px;
	font-size: 9px;
	margin-top: 6px;
	color: #1d1c1d;
	border-radius: 4px;
	letter-spacing: 0px;
	background: #e1e1e1;
}
.slack-content-container {
	margin-left: 37px;
}
.slack-content-container.legacy {
	min-height: 124px;
	border-left: 3px solid #4e5afe;
}
.footer-button {
	padding: 6px 11px !important;
	font-size: 13px !important;
	font-family: Lato !important;
	line-height: 1 !important;
	border-radius: 5px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	height: auto !important;
}
.take-action-button {
	@extend .footer-button;
	color: var(--white) !important;
	background: #007a5a !important;
}
.archive-button {
	color: #1d1c1d;
	@extend .footer-button;
	background: var(--white) !important;
	border: 1px solid #bab9ba !important;
}
.additional-info {
	white-space: pre;
}
</style>
